/* GOPSHOP 2.3 – Lieferzeit mit echtem Countdown (Section gop-delivery).
   Alles wird in der Shop-Zeitzone berechnet (nicht in der Zeit des Besuchers):
   Annahmeschluss, Versandtage, Feiertage, freie Tage und Zustellung in Werktagen. */
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('gop-delivery')) return;

  var DAY = 86400000;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Kalender (Tage als ganze Zahlen seit 1970, UTC) ---------- */
  function dayNum(y, m, d) { return Math.round(Date.UTC(y, m - 1, d) / DAY); }
  function civil(dn) {
    var x = new Date(dn * DAY);
    return { y: x.getUTCFullYear(), m: x.getUTCMonth() + 1, d: x.getUTCDate(), w: x.getUTCDay() };
  }
  function validDay(y, m, d) {
    var dn = dayNum(y, m, d);
    var c = civil(dn);
    return c.m === m && c.d === d ? dn : null;
  }

  // Ostersonntag (Gauß/Meeus) – für bewegliche Feiertage
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, n = Math.floor((a + 11 * h + 22 * l) / 451);
    var x = h + l - 7 * n + 114;
    return dayNum(y, Math.floor(x / 31), (x % 31) + 1);
  }

  // Bundesweite Feiertage in Deutschland
  var holCache = {};
  function isHolidayDE(dn) {
    var y = civil(dn).y;
    if (!holCache[y]) {
      var e = easter(y);
      var set = {};
      [dayNum(y, 1, 1), dayNum(y, 5, 1), dayNum(y, 10, 3), dayNum(y, 12, 25), dayNum(y, 12, 26),
        e - 2, e + 1, e + 39, e + 50].forEach(function (d) { set[d] = true; });
      holCache[y] = set;
    }
    return !!holCache[y][dn];
  }

  // Freie Tage aus dem Textfeld: 24.12.2026 · 2026-12-24 · 24.12. (jedes Jahr)
  function parseClosed(text) {
    var exact = {};
    var yearly = {};
    String(text || '').split(/[\s,;]+/).forEach(function (s) {
      var r, dn;
      if ((r = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s))) {
        dn = validDay(+r[1], +r[2], +r[3]);
      } else if ((r = /^(\d{1,2})\.(\d{1,2})\.(\d{4}|\d{2})$/.exec(s))) {
        dn = validDay(r[3].length === 2 ? 2000 + +r[3] : +r[3], +r[2], +r[1]);
      } else if ((r = /^(\d{1,2})\.(\d{1,2})\.?$/.exec(s))) {
        if (validDay(2024, +r[2], +r[1]) !== null) yearly[+r[2] + '-' + +r[1]] = true;
        return;
      }
      if (dn !== null && dn !== undefined) exact[dn] = true;
    });
    return function (dn) {
      if (exact[dn]) return true;
      var c = civil(dn);
      return !!yearly[c.m + '-' + c.d];
    };
  }

  /* ---------- Zeitzone: "jetzt" als Wanduhr-Zeit der Shop-Zeitzone ---------- */
  function makeZone(tz) {
    var f = null;
    [tz, 'Europe/Berlin'].some(function (zone) {
      if (!zone) return false;
      try {
        f = new Intl.DateTimeFormat('en-US', {
          timeZone: zone, hour12: false,
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric', second: 'numeric'
        });
        f.formatToParts(new Date());
        return true;
      } catch (e) {
        f = null;
        return false;
      }
    });
    return function partsAt(t) {
      var x = new Date(t);
      if (!f) {
        return { y: x.getFullYear(), m: x.getMonth() + 1, d: x.getDate(), h: x.getHours(), mi: x.getMinutes(), s: x.getSeconds() };
      }
      var o = {};
      f.formatToParts(x).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second };
    };
  }

  // Versatz der Zeitzone (ms) zu einem Zeitpunkt – berücksichtigt Sommer-/Winterzeit
  function offsetAt(partsAt, t) {
    var p = partsAt(t);
    return Math.round((Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - t) / 60000) * 60000;
  }

  // Wanduhr-Zeit (Tag + Uhrzeit in der Shop-Zeitzone) -> echter Zeitpunkt
  function zonedToUtc(partsAt, dn, h, mi) {
    var guess = dn * DAY + (h * 60 + mi) * 60000;
    return guess - offsetAt(partsAt, guess - offsetAt(partsAt, guess));
  }

  function int(v, lo, hi, def) {
    var n = parseInt(v, 10);
    if (isNaN(n)) return def;
    return Math.min(hi, Math.max(lo, n));
  }

  /* ---------- Berechnung ---------- */
  function compute(cfg, partsAt, isClosed, now) {
    var sat = cfg.sat === true;
    var hol = cfg.hol !== false;
    var cutH = int(cfg.cutH, 0, 23, 14);
    var cutM = int(cfg.cutM, 0, 59, 0);
    var min = int(cfg.min, 0, 60, 1);
    var max = int(cfg.max, 0, 60, 3);
    if (min > max) { var tmp = min; min = max; max = tmp; }

    function holiday(dn) { return hol && isHolidayDE(dn); }
    function shipDay(dn) {
      var w = civil(dn).w;
      return w !== 0 && (w !== 6 || sat) && !holiday(dn) && !isClosed(dn);
    }
    function deliveryDay(dn) {
      var w = civil(dn).w;
      return w !== 0 && w !== 6 && !holiday(dn);
    }
    function next(dn, test) {
      for (var i = 0; i < 120; i++) {
        dn += 1;
        if (test(dn)) return dn;
      }
      return null;
    }
    function addDeliveryDays(dn, n) {
      while (n > 0 && dn !== null) {
        dn = next(dn, deliveryDay);
        n -= 1;
      }
      return dn;
    }

    var p = partsAt(now);
    var today = dayNum(p.y, p.m, p.d);
    var ship = today;
    if (!shipDay(ship) || zonedToUtc(partsAt, ship, cutH, cutM) <= now) ship = next(today, shipDay);
    if (ship === null) return null;

    var from = addDeliveryDays(ship, min);
    var to = addDeliveryDays(ship, max);
    if (from === null || to === null) return null;

    /* Pre-Order (7.4): Werktage ab heute – Beschaffung bis +src, Zustellung +min bis +max (inkl. Beschaffung) */
    var pre = null;
    if (cfg.pre) {
      var pSrc = int(cfg.pre.src, 0, 60, 2);
      var pMin = int(cfg.pre.min, 0, 90, 7);
      var pMax = int(cfg.pre.max, 0, 90, 14);
      if (pMin > pMax) { var t2 = pMin; pMin = pMax; pMax = t2; }
      var pFrom = addDeliveryDays(today, pMin);
      var pTo = addDeliveryDays(today, pMax);
      var pSrcTo = addDeliveryDays(today, pSrc);
      if (pFrom !== null && pTo !== null && pSrcTo !== null) pre = { src: pSrcTo, from: pFrom, to: pTo };
    }

    return { today: today, ship: ship, from: from, to: to, pre: pre, left: zonedToUtc(partsAt, ship, cutH, cutM) - now };
  }

  /* ---------- Ausgabe ---------- */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(str, map, html) {
    return String(str || '').replace(/\[(\w+)\]/g, function (all, k) {
      if (!Object.prototype.hasOwnProperty.call(map, k)) return all;
      return html ? esc(map[k]) : String(map[k]);
    });
  }

  var SHORT = { weekday: 'short', day: 'numeric', month: 'short' };
  var DAYMONTH = { day: 'numeric', month: 'short' };
  var LONG = { weekday: 'long', day: 'numeric', month: 'long' };

  // Kalendertage liegen als UTC-Mitternacht vor -> mit timeZone 'UTC' formatieren (Mittag = sicher)
  var fmtCache = {};
  function formatter(lang, opts) {
    var key = lang + JSON.stringify(opts);
    if (!fmtCache[key]) {
      var o = { timeZone: 'UTC' };
      for (var k in opts) o[k] = opts[k];
      try { fmtCache[key] = new Intl.DateTimeFormat(lang, o); } catch (e) { fmtCache[key] = new Intl.DateTimeFormat(undefined, o); }
    }
    return fmtCache[key];
  }
  function noon(dn) { return new Date(dn * DAY + DAY / 2); }
  function fmtDay(lang, opts, dn) { return formatter(lang, opts).format(noon(dn)); }
  function fmtRange(lang, opts, a, b) {
    if (a === b) return fmtDay(lang, opts, a);
    var f = formatter(lang, opts);
    if (typeof f.formatRange === 'function') {
      try { return f.formatRange(noon(a), noon(b)); } catch (e) { /* Fallback unten */ }
    }
    return f.format(noon(a)) + ' – ' + f.format(noon(b));
  }

  /* ---------- Gemeinsamer 30-Sekunden-Takt ---------- */
  var live = [];
  var timer = 0;
  function tick() {
    live = live.filter(function (el) { return el.isConnected; });
    live.forEach(function (el) { el.update(); });
    if (!live.length && timer) {
      clearInterval(timer);
      timer = 0;
    }
  }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
  });

  class GopDelivery extends HTMLElement {
    connectedCallback() {
      if (this._cfg) {
        // Wieder eingehängt (z. B. im Theme-Editor verschoben)
        this.update();
        this._start();
        if (!this.classList.contains('gop-dl-in')) this._animate();
        else this.classList.add('gop-dl-done');
        this._watch();
        return;
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this), { once: true });
        return;
      }
      var node = this.querySelector('script[data-gop-dl-config]');
      if (!node) return;
      try {
        this._cfg = JSON.parse(node.textContent);
      } catch (e) {
        return;
      }
      this._t = this._cfg.t || {};
      this._zone = makeZone(this._cfg.tz);
      this._closed = parseClosed(this._cfg.closed);
      this._lang = document.documentElement.getAttribute('lang') || undefined;
      var self = this;
      this._el = {};
      ['msg', 'order', 'ship', 'deliver', 'pmsg', 'psrc', 'pdeliver'].forEach(function (k) {
        self._el[k] = Array.prototype.slice.call(self.querySelectorAll('[data-dl="' + k + '"]'));
      });
      this._steps = this.querySelector('[data-dl="steps"]');
      this._last = {};
      this.update();
      this._start();
      this._animate();
      this._tabs();
    }

    disconnectedCallback() {
      var self = this;
      live = live.filter(function (el) { return el !== self; });
      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
      clearTimeout(this._doneTimer);
      if (this._vio) {
        this._vio.disconnect();
        this._vio = null;
      }
    }

    _start() {
      if (live.indexOf(this) === -1) live.push(this);
      if (!timer) timer = setInterval(tick, 30000);
    }

    _set(key, value, html) {
      var els = this._el[key];
      if (!els || !els.length || !value || this._last[key] === value) return;
      this._last[key] = value;
      els.forEach(function (el) {
        if (html) el.innerHTML = value;
        else el.textContent = value;
      });
    }

    update() {
      var r;
      try {
        r = compute(this._cfg, this._zone, this._closed, Date.now());
      } catch (e) {
        r = null;
      }
      if (!r) return; // statische Anzeige bleibt stehen

      var t = this._t;
      var lang = this._lang;
      var mins = Math.max(1, Math.floor(r.left / 60000));
      var h = Math.floor(mins / 60);
      var time = h > 0 ? fill(t.hm, { h: h, m: mins % 60 }) : fill(t.m, { m: mins });
      var diff = r.ship - r.today;
      var msg;
      /* Standard (7.2): ehrlicher Zeitraum statt Versand-Countdown – kein festes Versprechen */
      if (this._cfg.mode !== 'countdown' && t.range) msg = fill(t.range, { from: fmtDay(lang, SHORT, r.from), to: fmtDay(lang, SHORT, r.to) }, true);
      else if (diff === 0) msg = fill(t.today, { time: time }, true);
      else if (diff === 1) msg = fill(t.tomorrow, { time: time }, true);
      else msg = fill(t.later, { date: fmtDay(lang, LONG, r.ship) }, true);

      this._set('msg', msg, true);
      this._set('order', fill(t.todayDate, { date: fmtDay(lang, DAYMONTH, r.today) }));
      this._set('ship', fmtDay(lang, SHORT, r.ship));
      this._set('deliver', fmtRange(lang, SHORT, r.from, r.to));
      if (r.pre) {
        if (t.preRange) this._set('pmsg', fill(t.preRange, { from: fmtDay(lang, SHORT, r.pre.from), to: fmtDay(lang, SHORT, r.pre.to) }, true), true);
        this._set('psrc', fill(t.until || '[date]', { date: fmtDay(lang, SHORT, r.pre.src) }));
        this._set('pdeliver', fmtRange(lang, SHORT, r.pre.from, r.pre.to));
      }
      this.classList.add('gop-dl-live');
    }

    // Linie zeichnet sich, Symbole erscheinen nacheinander – sobald sichtbar
    _animate() {
      var self = this;
      var steps = this._steps;
      if (reduce || !steps || !('IntersectionObserver' in window)) return;
      this.classList.add('gop-dl-armed');
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || !self._io) return;
          self._io.disconnect();
          self._io = null;
          self.classList.add('gop-dl-in');
          self._doneTimer = setTimeout(function () { self.classList.add('gop-dl-done'); }, 2300);
        });
      }, { threshold: 0.45 });
      this._io.observe(steps);
    }

    /* 7.4 – Umschalter Lagerware / Pre-Order. Der Takt ist die CSS-Animation des Fortschrittsstrichs
       im aktiven Chip (animationend = weiter) → Pause bei Hover/Fokus/unsichtbar kostet kein JS. */
    _tabs() {
      var self = this;
      var tabs = Array.prototype.slice.call(this.querySelectorAll('[data-dl-tab]'));
      var panels = Array.prototype.slice.call(this.querySelectorAll('[data-dl-panel]'));
      if (tabs.length < 2 || panels.length < 2 || this._tabsOn) return;
      this._tabsOn = true;
      this._cur = 0;

      function show(i, focus) {
        self._cur = i;
        tabs.forEach(function (tb, k) {
          var on = k === i;
          tb.classList.toggle('is-on', on);
          tb.setAttribute('aria-selected', String(on));
          tb.tabIndex = on ? 0 : -1;
          if (on && focus) tb.focus();
        });
        panels.forEach(function (p, k) {
          var on = k === i;
          p.classList.toggle('is-on', on);
          if (on) p.removeAttribute('inert');
          else p.setAttribute('inert', '');
        });
      }
      function stopAuto() {
        self.classList.remove('gop-dl-auto');
      }

      tabs.forEach(function (tb, k) {
        tb.addEventListener('click', function () {
          stopAuto();
          show(k, false);
        });
        tb.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (e.key === 'Home') d = -k;
          if (e.key === 'End') d = tabs.length - 1 - k;
          if (!d) return;
          e.preventDefault();
          stopAuto();
          show((k + d + tabs.length) % tabs.length, true);
        });
        var bar = tb.querySelector('.gop-dl__prog');
        if (bar) {
          bar.addEventListener('animationend', function () {
            if (!self.classList.contains('gop-dl-auto') || self._cur !== k) return;
            show((k + 1) % tabs.length, false);
          });
        }
      });

      /* Auto-Wechsel nur mit Einstellung, ohne „weniger Bewegung“, und nur solange sichtbar */
      if (!this.hasAttribute('data-auto') || reduce || !('IntersectionObserver' in window)) return;
      this.classList.add('gop-dl-auto', 'gop-dl-off');
      this._watch();
    }

    /* Sichtbarkeit beobachten (auch nach erneutem Einhängen, z. B. wenn ein Skript den Bereich verschiebt) */
    _watch() {
      var self = this;
      if (this._vio || !this.classList.contains('gop-dl-auto')) return;
      this._vio = new IntersectionObserver(function (en) {
        self.classList.toggle('gop-dl-off', !en[en.length - 1].isIntersecting);
      }, { threshold: 0.2 });
      this._vio.observe(this);
    }
  }

  window.customElements.define('gop-delivery', GopDelivery);
})();
